export default {
  zh: {
    placeholder: '双击编辑',
    inputPlaceholder: '添加名称'
  },
  en: {
    placeholder: 'Double Click to Edit',
    inputPlaceholder: 'Add a name'
  }
};



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/EditableTitle/i18n.js